import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
export function FarmingtonHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-1288">
      <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1289">
        <MapPin className="w-4 h-4" data-id="element-1290" />
        Serving Farmington, MI
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-1291">
        Taekwondo Classes & Martial Arts Programs Near Farmington, MI
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-1292">
        Storm Taekwondo is deeply connected to the Farmington community,
        providing a safe, structured place for local kids and adults to learn
        martial arts.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-1293">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-1294">
          Start With a Trial Class
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary" data-id="element-1295">
          Call 517-220-0621
        </a>
      </div>
    </div>;
}